import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { SeErrorStateMatcher } from '../../../utils/error-state-matcher';

/**
 * Base Editor Custom AgGrid for Letter Input.
 * It contains common functionalities used by LetterCellEditorInlineComponent
 * and LetterCellEditorPopupComponent
 */
@Component({
    selector: 'se-letter-cell-editor-base',
    template: '',
})
export class LetterCellEditorBaseComponent implements OnInit {

    /**
     * Current value of the cell
     * ngModel setted by LetterCellEditorComponent
     */
    @Input() value: string;

    /**
     *  (Optional) it allows to specify a set of not admissible chars
     * passed by LetterCellEditorComponent
     */
    @Input() notAdmissibleChars: Array<string>;

    /**
     *  (Optional) it allows to specify if the filed is mandatory
     */
    @Input() required: boolean;

    /**
     * Event emitted when the reactive form is ready
     */
    @Output() formReady: EventEmitter<FormControl> = new EventEmitter<FormControl>();

    @ViewChild('letterInput', { static: false, read: ElementRef }) letterInput: ElementRef;

    // This editor acepts only letters no special char
    LETTERS_REGEXP = /^[a-zA-Z ]*$/;
    LETTER_STR = '[a-zA-Z ]';

    // Every char other than a-zA-z and blank  chars different
    NOT_LETTER_REGEXP = /[^A-Za-z ]/g;

    notAdmissibleCharsString: string;

    allAdmissibleCharsString: string;
    allAdmissibleCharsRegexp: RegExp;

    formControl: FormControl;
    matcher = new SeErrorStateMatcher();

    @HostListener('keypress', ['$event']) onKeyPress(event) {
        return this.allAdmissibleCharsRegexp.test(event.key);
    }

    @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
        this.validateFields(event);
    }

    ngOnInit(): void {
        this.configPatternForAvailableChars();

        // Definizione FormControl
        const validators: Array<ValidatorFn> = [];

        this.formControl = new FormControl(this.value, []);

        validators.push(Validators.pattern(this.allAdmissibleCharsRegexp));
        if (this.required) { validators.push(Validators.required); };

        this.formControl.setValidators(validators);
    }

    private configPatternForAvailableChars() {
        // regExp for not admissible chars
        if (this.notAdmissibleChars) {
            this.notAdmissibleCharsString = '(?![' + this.notAdmissibleChars.join('') + '])';
            this.allAdmissibleCharsString = this.notAdmissibleCharsString + this.LETTER_STR;
            this.allAdmissibleCharsRegexp = new RegExp(this.allAdmissibleCharsString);
        } else {
            this.allAdmissibleCharsRegexp = this.LETTERS_REGEXP;
        }

    }

    private validateFields(event) {
        setTimeout(() => {
            this.letterInput.nativeElement.value = this.letterInput.nativeElement.value
                .replace(this.NOT_LETTER_REGEXP, '')
                .replace(/\s/g, '');

            let notAdmissibleRegExp: RegExp;
            if (this.notAdmissibleChars) {
                notAdmissibleRegExp = new RegExp('[' + this.notAdmissibleChars.join() + ']', 'g');
            }
            this.letterInput.nativeElement.value = this.letterInput.nativeElement.value
                .replace(notAdmissibleRegExp, '')
                .replace(/\s/g, '');

            event.preventDefault();
        }, 100);
    }

}
